import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize, from } from 'rxjs';

import { AccountService } from '../services/account.service';
import { SpinnerService } from '../services/spinner.service';

@Component({
  selector: 'app-password-request',
  templateUrl: './password-request.component.html',
  styleUrls: ['./password-request.component.css'],
})
export class PasswordRequestComponent implements OnInit {
  public passwordRequestForm: FormGroup;
  public submittedPasswordRequestForm = false;
  public emailSent = false;

  constructor(
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    private accountService: AccountService
  ) {}

  ngOnInit(): void {
    this.preparePasswordRequestForm();
  }

  /**
   * Prepares password request form
   */
  preparePasswordRequestForm(): void {
    this.passwordRequestForm = this.formBuilder.group({
      username: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$'
          ),
        ],
      ],
    });
  }

  /**
   * Submits password request form
   */
  onSubmit(): void {
    this.submittedPasswordRequestForm = true;
    if (this.passwordRequestForm.valid) {
      this.spinnerService.show();

      from(
        this.accountService.forgotPassword(
          this.passwordRequestForm.get('username').value,
          window.location.origin + '/reset-password'
        )
      )
        .pipe(finalize(() => this.spinnerService.hide()))
        .subscribe({
          next: (res) => {
            this.emailSent = true;
          },
        });
    }
  }
}
